<template>
  <div :class="$style.base">
    <div ref="el" :class="$style.inner">
      <div :class="$style.selectedLanguage" @click="isExpanded = !isExpanded" v-test="'select-language'">
        <Flag :language="selectedLanguage" v-test="`selected-language-${selectedLanguage}`"/>
      </div>
      <div :class="$style.languages" v-show="isExpanded">
        <Flag
          v-for="(language, index) in languages"
          :key="index"
          :language="language"
          @click="selectLanguage(language)"
          v-test="'select-language-option'"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import i18n from '@/i18n';
import { onClickOutside } from '@vueuse/core';
import Flag from './Flag.vue';
import { useCompanyStore } from '@/stores/company';

const languages = ['en', 'nl', 'de', 'fr', 'es'];

const selectedLanguage = ref(i18n.locale.value);
const isExpanded = ref(false);

const selectLanguage = (value: string) => {
  selectedLanguage.value = value;
  isExpanded.value = false;
};

watch(selectedLanguage, (value) => {
  i18n.locale.value = value;
});

const el = ref();
onClickOutside(el, () => (isExpanded.value = false));

const { settings } = useCompanyStore();
if (settings.browser_language_override) {
  const navigatorLang = window.navigator.language.split('-')[0];
  selectedLanguage.value = languages.includes(navigatorLang)
    ? navigatorLang
    : selectedLanguage.value;
}
</script>

<style lang="scss" module>
.base {
  display: inline-flex;
  align-items: center;
  padding: $spacing * 0.5;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  z-index: 2;
}

.inner {
  position: relative;
}

.selectedLanguage {
  display: flex;
  padding: 10px;
  cursor: pointer;
}

.languages {
  position: absolute;
  left: 0;
  top: 100%;
  display: flex;
  gap: $spacing;
  padding: $spacing;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
</style>
